// Global Button Styles for modern look and feel
// Import and use these styles throughout the application for consistency

export const ButtonStyles = {
    // Primary action buttons (Save, Submit, Confirm)
    primary: {
        background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
        border: "none",
        borderRadius: "25px",
        padding: "12px 30px",
        fontWeight: "600",
        fontSize: "16px",
        boxShadow: "0 4px 15px rgba(17, 153, 142, 0.4)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Primary small button
    primarySm: {
        background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
        border: "none",
        borderRadius: "20px",
        padding: "6px 16px",
        fontWeight: "600",
        fontSize: "13px",
        boxShadow: "0 3px 10px rgba(17, 153, 142, 0.3)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Secondary action buttons (Back, Return)
    secondary: {
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        border: "none",
        borderRadius: "25px",
        padding: "8px 20px",
        fontWeight: "600",
        boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Secondary small button
    secondarySm: {
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        border: "none",
        borderRadius: "20px",
        padding: "6px 16px",
        fontWeight: "600",
        fontSize: "13px",
        boxShadow: "0 3px 10px rgba(102, 126, 234, 0.3)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Danger/Cancel buttons (Cancel, Delete, Remove)
    danger: {
        background: "linear-gradient(135deg, #eb3349 0%, #f45c43 100%)",
        border: "none",
        borderRadius: "25px",
        padding: "12px 30px",
        fontWeight: "600",
        fontSize: "16px",
        boxShadow: "0 4px 15px rgba(235, 51, 73, 0.4)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Danger small button
    dangerSm: {
        background: "linear-gradient(135deg, #eb3349 0%, #f45c43 100%)",
        border: "none",
        borderRadius: "20px",
        padding: "6px 16px",
        fontWeight: "600",
        fontSize: "13px",
        boxShadow: "0 3px 10px rgba(235, 51, 73, 0.3)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Success/Add buttons (Add new items)
    success: {
        background: "linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)",
        border: "none",
        borderRadius: "25px",
        padding: "8px 20px",
        fontWeight: "600",
        boxShadow: "0 4px 15px rgba(86, 171, 47, 0.4)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Success small button (for inline Add buttons)
    successSm: {
        background: "linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)",
        border: "none",
        borderRadius: "20px",
        padding: "6px 16px",
        fontWeight: "600",
        fontSize: "13px",
        boxShadow: "0 3px 10px rgba(86, 171, 47, 0.3)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Warning buttons (Edit, Update)
    warning: {
        background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        border: "none",
        borderRadius: "25px",
        padding: "8px 20px",
        fontWeight: "600",
        boxShadow: "0 4px 15px rgba(240, 147, 251, 0.4)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Warning small button
    warningSm: {
        background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        border: "none",
        borderRadius: "20px",
        padding: "6px 16px",
        fontWeight: "600",
        fontSize: "13px",
        boxShadow: "0 3px 10px rgba(240, 147, 251, 0.3)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Info buttons (View, Details)
    info: {
        background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
        border: "none",
        borderRadius: "25px",
        padding: "8px 20px",
        fontWeight: "600",
        boxShadow: "0 4px 15px rgba(79, 172, 254, 0.4)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Info small button
    infoSm: {
        background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
        border: "none",
        borderRadius: "20px",
        padding: "6px 16px",
        fontWeight: "600",
        fontSize: "13px",
        boxShadow: "0 3px 10px rgba(79, 172, 254, 0.3)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Orange/Accent buttons
    orange: {
        background: "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
        border: "none",
        borderRadius: "25px",
        padding: "8px 20px",
        fontWeight: "600",
        boxShadow: "0 4px 15px rgba(247, 151, 30, 0.4)",
        transition: "all 0.3s ease",
        color: "#fff"
    },

    // Orange small button
    orangeSm: {
        background: "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
        border: "none",
        borderRadius: "20px",
        padding: "6px 16px",
        fontWeight: "600",
        fontSize: "13px",
        boxShadow: "0 3px 10px rgba(247, 151, 30, 0.3)",
        transition: "all 0.3s ease",
        color: "#fff"
    }
};

// Helper function to combine styles with additional custom styles
export const mergeStyles = (baseStyle, customStyle = {}) => ({
    ...baseStyle,
    ...customStyle
});

export default ButtonStyles;



// WEBPACK FOOTER //
// ./src/constants/ButtonStyles.js